
export const UNKNOWN_REQUEST_ERROR = "error:failure.unknownRequestError"